import React from 'react';
import PropTypes from 'prop-types';
import css from './SlotLabel.css';

export default class SlotLabelInfoRow extends React.Component {

  get name() {
    return this.props.isService && typeof this.props.ownerName !== "undefined"
      ? <div className={css['owner-name']}>{this.props.ownerName}</div>
      : null;
  }

  get title() {
    return this.props.isService && typeof this.props.ownerTitle !== "undefined"
      ? <div className={css['owner-title']}>{this.props.ownerTitle}</div>
      : null;
  }

  get locationColor() {
    // Renders grayish color if there isnt name or title OR if it's a connection
    return this.props.isService && this.props.ownerName && this.props.ownerTitle ? null : "#616365";
  }

  get appointmentCourseContext() {
    return !this.props.courseContextName ? null
      : <div className={css['course-context']}>{this.props.courseContextName}</div>;
  }

  render() {
    return (
      <div className={css['info-block']}>
        {this.name}
        {this.title}
        <div className={css['location']} style={{color: this.locationColor}}>{this.props.location}</div>
        {this.appointmentCourseContext}
      </div>
    );
  }
}

SlotLabelInfoRow.propTypes = {
  isService: PropTypes.bool.isRequired,
  location: PropTypes.string,
  ownerName: PropTypes.string,
  ownerTitle: PropTypes.string,
  courseContextName: PropTypes.string
};
